import React from 'react';
import { SelectTreeField } from '@/components/form/fields/SelectTreeField';
import { TextAreaField } from '@/components/form/fields/TextAreaField';
import { SelectField } from '@/components/form/fields/SelectField';
import { ITypePriorityAndModule } from '@/api/testCase';
import { tagOption } from '@/utils/constants/testCase';
import { useParams } from 'react-router-dom';
import { ProjectAssigneeService } from '@/api/projectAssignee';

type TestCaseProps = {
  optionsData?: ITypePriorityAndModule;
};

export const TestCaseForm: React.FC<TestCaseProps> = ({ optionsData }) => {
  const { id: projectId } = useParams<{ id: string }>();
  const { data: assigneeOptionsData } =
    ProjectAssigneeService.useGetOptions(projectId);

  const userOptions = assigneeOptionsData?.assign ?? [];

  return (
    <div className="flex flex-row gap-10">
      <div className="flex flex-col w-full gap-5">
        <SelectTreeField
          name="module_id"
          label="Select User Story"
          options={optionsData?.module}
          hasRequiredAsterisk
        />

        <TextAreaField
          name="title"
          label="Test Case Title"
          hasRequiredAsterisk
        />

        <TextAreaField name="description" label="Description" />
      </div>

      <div className="flex flex-col w-full gap-5">
        <SelectField
          options={optionsData?.type}
          name="type"
          label="Type"
          hasRequiredAsterisk
          isSearchable
        />

        <SelectField
          options={userOptions}
          name="pic_id"
          label="PIC"
          placeholder="Select PIC"
          hasRequiredAsterisk
        />

        <SelectField
          options={optionsData?.priority}
          name="priority"
          label="Priority"
          hasRequiredAsterisk
        />

        <SelectField
          options={tagOption}
          name="tag"
          label="Tag"
          hasRequiredAsterisk
        />

        <TextAreaField
          name="precondition"
          label="Precondition"
          hasRequiredAsterisk
        />
      </div>
    </div>
  );
};
